export const ALL_OTHERS_ID = 0;
export const ALL_COUNTRIES_ID = -1;
export const ALL_OTHERS_LABEL = 'All others';
